import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {DjPsychoGameAssets} from "../DjPsychoGameAssets";
import {TimelineLite} from 'gsap';
import {DjPsycho} from "../DjPsycho";
import {DjPsychoWinTypes, IWinRatioConfig} from "../server/IDjPsychoData";

export class DjPsychoTotalWinView extends PIXI.Container implements StageLayer {

    private _totalWinCountUp: BasicBitmapCountUp;
    private _mainTl: TimelineLite;
    private _targetScale: number;
    private _totalWinAmount: number;
    private _playSound: boolean = true;
    private _endSound: boolean = true;

    constructor() {
        super();
        this.name = "DjPsychoTotalWinView";
        this.init();
    }

    public getTotalWinTimeline(totalWin: number): TimelineLite {
        this._mainTl = new TimelineLite();
        if (this._mainTl && this._mainTl.isActive()) {
            this._mainTl.pause();
            this._mainTl.kill();
        }
        this._totalWinAmount = totalWin;
        this._playSound = true;

        if ((DjPsycho.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && totalWin <= DjPsycho.getCost()) || (DjPsycho.model.winRatio < 1)) { // second condition is for #119's 2nd point
            this._playSound = false;
            this._totalWinCountUp.visible = false;

            return this._mainTl;
        }

        const winRatioConfig: IWinRatioConfig = DjPsycho.model.winRatioConfig;
        let targetScale: number = 0.5;
        if (winRatioConfig.type === DjPsychoWinTypes.SMALL) {
            targetScale = 0.7;
        } else if (winRatioConfig.type === DjPsychoWinTypes.MEDIUM) {
            targetScale = 0.8;
        } else if (winRatioConfig.type === DjPsychoWinTypes.LARGE) {
            targetScale = 0.9;
        }
        this._targetScale = targetScale;

        this._mainTl.add(() => {
            this._totalWinCountUp.visible = true;
        }, 0);

        this._endSound = false;
        this._totalWinCountUp.scale.set(targetScale, targetScale);

        if (winRatioConfig.duration === 0) {
            this._totalWinCountUp.getCountAnimation(totalWin, totalWin, winRatioConfig.duration);
            DjPsycho.keypadPlugin.setWin(DjPsycho.model.gameData.accumulatedRoundWin, true, DjPsycho.isWinBelowStake());

            this._mainTl.add(() => {
                // #140, #141
                this._totalWinCountUp.alpha = 1;

                DjPsycho.soundPlayer.stopCountUp();
            }, 0);
            this._endSound = true;
        } else {
            this._mainTl.add(() => {
                DjPsycho.soundPlayer.startCountUp();
            }, 0);
            this._totalWinCountUp.alpha = 0;
            this._mainTl.to(this._totalWinCountUp, {
                duration: 0.2,
                alpha: 1,
                ease: "power3.out"
            }, 0);
            this._mainTl.add(this._totalWinCountUp.getCountAnimation(0, totalWin, winRatioConfig.duration), 0);
            this._mainTl.to(this._totalWinCountUp.scale, {
                duration: winRatioConfig.duration,
                x: targetScale,
                y: targetScale,
                ease: "power3.out"
            }, 0);
            this._mainTl.add(() => {
                this._totalWinCountUp.stopAt(totalWin);
                this._endSound = true;
                DjPsycho.soundPlayer.stopCountUp();

                DjPsycho.keypadPlugin.setWin(DjPsycho.model.gameData.accumulatedRoundWin, true, DjPsycho.isWinBelowStake());
            });
        }

        this._mainTl.to(this._totalWinCountUp, {
            duration: 0.3,
            alpha: 0,
            ease: "power3.out"
        }, "+=0.5");

        this._mainTl.add(() => {
            this._totalWinCountUp.visible = false;
            this._totalWinCountUp.alpha = 1;
        });

        return this._mainTl;
    }

    public hardAbort(): void {
        if (this._mainTl) {
            this._mainTl.pause();
            this._mainTl.kill();
            DjPsycho.keypadPlugin.setWin(DjPsycho.model.gameData.accumulatedRoundWin, true, DjPsycho.isWinBelowStake());

            // #140, #141
            if (!this._totalWinCountUp.alpha) {
                this._totalWinCountUp.alpha = 1;
            }

            this._totalWinCountUp.scale.set(this._targetScale);
            this._totalWinCountUp.visible = true;
            this._totalWinCountUp.stopAt(this._totalWinAmount);
            this.fadeOutWinPres(0.3, 0.5);
            if (this._playSound && !this._endSound) {
                this._endSound = true;
                DjPsycho.soundPlayer.stopCountUp();
            }
        }
    }

    private init(): void {
        this._totalWinCountUp = new BasicBitmapCountUp({
            fontName: DjPsychoGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 52,
        }, 680, new PIXI.Point(0.5, 0.5));
        this._totalWinCountUp.position.set(360);
        this._totalWinCountUp.visible = false;
        this.addChild(this._totalWinCountUp);

        if (DjPsycho.model.isRestore) {
            DjPsycho.keypadPlugin.setWin(DjPsycho.model.initData.accumulatedRoundWin, true, DjPsycho.isWinBelowStake());
        }
    }

    private fadeOutWinPres(duration: number, delay: number): void {
        const tl: TimelineLite = new TimelineLite({
            delay: delay
        });
        tl.to(this._totalWinCountUp, {
            duration: duration,
            alpha: 0,
            ease: "power3.out"
        });
        tl.add(() => {
            this._totalWinCountUp.visible = false;
        });
    }
}